'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMetadataRecord;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _MessageMetadataRecords = require('conversations-schema/records/MessageMetadataRecords');

var _buildMetadataWithRichText = require('./buildMetadataWithRichText');

var _buildMetadataWithRichText2 = _interopRequireDefault(_buildMetadataWithRichText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildMetadataRecord(props) {
  var metadataProps = (0, _get2.default)('metadata', props);
  var type = (0, _get2.default)(_PubNubMessageTypes.MESSAGE_TYPE_ID, metadataProps);

  switch (type) {
    case _PubNubMessageTypes.CHAT_MESSAGE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _MessageMetadataRecords.ChatMessageMetadata);

    case _PubNubMessageTypes.INITIAL_MESSAGE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _MessageMetadataRecords.InitialMessageMetadata);

    case _PubNubMessageTypes.OFFLINE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _MessageMetadataRecords.OfflineMessageMetadata);

    case _PubNubMessageTypes.BLOCK:
      return (0, _MessageMetadataRecords.BlockMessageMetadata)(metadataProps);

    case _PubNubMessageTypes.LAST_SEEN:
      return (0, _MessageMetadataRecords.LastSeenMessageMetadata)(metadataProps);

    case _PubNubMessageTypes.OPEN_CHANNEL:
      return (0, _MessageMetadataRecords.OpenChannelMessageMetadata)(metadataProps);

    case _PubNubMessageTypes.CLOSE_CHANNEL:
      return (0, _MessageMetadataRecords.CloseChannelMessageMetadata)(metadataProps);

    default:
      window.Raven.captureMessage('MESSAGE_WITH_INVALID_TYPE', {
        extra: (0, _toJS2.default)(props)
      });
      return null;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/PubNubMessageFactory/buildMetadataRecord.js
// module id = 302
// module chunks = 0 1